import { Invoice } from '../../../buy/services/invoice.model';
import { Action } from '../../../common/actions/core/action';

export class NoAuthBillInfoEditDialogAction implements Action {
  constructor(public invoice: Invoice) {}
}



// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info-edit/bill-info-edit-dialog.action.ts